import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IRefuseCreatePaymentLiabilityVM } from '../../models/model';

@Component({
standalone: false,
  selector: 'app-hide-liability-confirmation-dialog',
  styleUrls: ['./liabilities-with-unknown-status-dialog.component.scss'],
  templateUrl: './liabilities-with-unknown-status-dialog.component.html',
})
export class LiabilitiesWithUnknownStatusDialogComponent {
  public liabilities: IRefuseCreatePaymentLiabilityVM[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: { liabilities: IRefuseCreatePaymentLiabilityVM[] }) {
    this.liabilities = data.liabilities;
  }
}
